export type AiExampleCategory = "clients" | "schedule" | "stats" | "analytics" | "howTo" | "general" | "support";

export interface IAiExampleQuestion {
  text: string;
  category: AiExampleCategory;
  /** Needs the owner-or-manager tools (get_occupancy_trend, list_at_risk_clients). */
  managersOnly?: boolean;
}

/** The pool the empty chat picks its example chips from; a few new ones every time. */
export const aiExampleQuestions: IAiExampleQuestion[] = [
  // A client
  { category: "clients", text: "Една клиентка не може да влезе в профила си — разбери защо" },
  { category: "clients", text: "Клиент казва, че не получава кода за потвърждение. Какво става?" },
  { category: "clients", text: "Колко посещения остават на картата на клиент?" },
  { category: "clients", text: "Какви резервации има клиентка за следващата седмица?" },
  { category: "clients", text: "Защо клиент не може да се запише за клас през портала?" },
  { category: "clients", text: "Клиент е маркиран като нередовен — какво означава и как да го махна?" },
  { category: "clients", text: "Има ли клиент с два акаунта на един и същ телефон?" },

  // The schedule
  { category: "schedule", text: "Колко души са записани за утре?" },
  { category: "schedule", text: "Кой е записан за утрешния сутрешен клас?" },
  { category: "schedule", text: "Кои класове тази седмица са почти пълни?" },
  { category: "schedule", text: "Има ли класове със свободни места днес следобед?" },
  { category: "schedule", text: "Кои класове следващата седмица още нямат нито една резервация?" },
  { category: "schedule", text: "Кой чака в листата на чакащите за съботните класове?" },
  { category: "schedule", text: "Кой инструктор какви класове води утре?" },

  // Numbers
  { category: "stats", text: "Колко резервации имахме този месец спрямо миналия?" },
  { category: "stats", text: "Кой е най-посещаваният ни клас през последния месец?" },
  { category: "stats", text: "Колко нови клиенти се регистрираха този месец?" },
  { category: "stats", text: "Колко карти продадохме през последните 30 дни?" },
  { category: "stats", text: "Колко неявявания имахме тази седмица?" },
  { category: "stats", text: "Как върви обектът този месец? Дай ми кратко резюме" },
  { category: "stats", text: "Колко резервации бяха отказани през последните две седмици?" },

  // Trends and forecasts (owners and managers)
  { category: "analytics", managersOnly: true, text: "Кои клиенти намалиха посещенията си напоследък?" },
  { category: "analytics", managersOnly: true, text: "Кои редовни клиенти не са идвали от три седмици?" },
  { category: "analytics", managersOnly: true, text: "На кого изтича картата скоро, а няма запазен час?" },
  { category: "analytics", managersOnly: true, text: "Каква заетост да очакваме следващия месец?" },
  { category: "analytics", managersOnly: true, text: "В кои дни и часове сме най-пълни?" },
  { category: "analytics", managersOnly: true, text: "Как се промени заетостта спрямо същия период миналата година?" },
  { category: "analytics", managersOnly: true, text: "Растат ли или падат посещенията през последните два месеца?" },
  { category: "analytics", managersOnly: true, text: "Направи ми списък с клиенти, на които да пиша, за да се върнат" },
  { category: "analytics", managersOnly: true, text: "Кога е най-добре да добавим нов клас според заетостта?" },

  // How to do it in Planny
  { category: "howTo", text: "Как да направя клас, който се повтаря всеки вторник и четвъртък?" },
  { category: "howTo", text: "Как да заредя карта на клиент?" },
  { category: "howTo", text: "Как клиентите да получават напомняне преди часа си?" },
  { category: "howTo", text: "Как да сменя крайния срок за отказ на резервация?" },
  { category: "howTo", text: "Как да добавя нов служител и какви права да му дам?" },
  { category: "howTo", text: "Как да пратя съобщение до всички клиенти наведнъж?" },
  { category: "howTo", text: "Как да блокирам цял ден в календара?" },
  { category: "howTo", text: "Как да приемам онлайн плащания със Stripe?" },
  { category: "howTo", text: "Как да направя семейна карта?" },
  { category: "howTo", text: "Какво означава статус „Платена без присъствие“?" },

  // Anything else
  { category: "general", text: "Напиши публикация за Instagram за новия ни клас" },
  { category: "general", text: "Измисли промоция, с която да привлечем нови клиенти през зимата" },
  { category: "general", text: "Напиши учтиво съобщение до клиент, който пропусна часа си" },
  { category: "general", text: "Дай ми 5 идеи за тематични класове за празниците" },
  { category: "general", text: "Напиши кратко приветствено съобщение за нови клиенти" },
  { category: "general", text: "Помогни ми да отговоря на негативен отзив в Google" },
  { category: "general", text: "Напиши пост за Facebook, че имаме свободни места тази седмица" },

  // The Planny team
  { category: "support", text: "Нещо не работи в Planny — помогни ми да подготвя запитване до екипа" },
  { category: "support", text: "Имам идея за нова функция в Planny — как да я предложа?" },
  { category: "support", text: "Ще прикача снимка на грешка — кажи ми какво означава" },
];
